// Production
const DNS = 'https://api.red-cube.co.uk'
export const SCOKET_FILE_UPLOAD_BASE_URl = `https://socketfile.red-cube.co.uk:8035/fsapi` //file-system-service

// // // // // //Kong base url
// const DNS = 'http://finifyapi.redltd.tech:8000'
// export const SCOKET_FILE_UPLOAD_BASE_URl = `http://3.140.82.112:9035/fsapi` //file-system-service


export const API_BASE_URL = `${DNS}/dapi` //upay_dpay_service
// export const API_BASE_URL = `http://localhost:5001/dapi` //upay_dpay_service
export const pms_admin_service = `${DNS}/adsapipms` //pms_admin_service
// export const pms_admin_service = `http://localhost:5001/pmsadsapi` //pms_admin_service
export const Rilac_Report_Service = `${DNS}/relac` //rilac_report_service
export const PMS_Notification_Campaign_mgt_service = `${DNS}/pmnsapi` //upay-notification-service-pms
// export const PMS_Notification_Campaign_mgt_service = `http://localhost:5001/pmnsapi` //upay-notification-service-pms
export const PMS_user_management_service = `${DNS}/usrm` //upay_user_managment
// export const PMS_user_management_service = `http://localhost:5001/usrm` //upay_user_managment
export const BMS_API_BASE_URL = `${DNS}/bms` //bms_service kowshik vai
export const rilac_poll_service = `${DNS}/posapi` //poll_service
export const upay_log_service = `${DNS}/bmshst` //upay_log_service
export const alert_service = `${DNS}/caapi` //campaign_alert_service
export const tier_management_service = `${DNS}/csapi` //tier_management_service
export const plan_service = `${DNS}/plapi` //plan_service
// export const plan_service = `http://localhost:5003/plapi` //plan_service

export const fb_post_service = `${DNS}/fbpost` //rilac_facebook_pagepost_service
export const rilac_payment_service = `${DNS}/papi` //rilac_payment_service  //needs url change later
export const rilac_registration_service = `${DNS}/rrapi` //rilac_payment_service  //needs url change later
export const rilac_bulk_sms_service = `${DNS}/rbsapi` //rilac_bulk_sms 
// export const rilac_bulk_sms_service = `http://localhost:5001/rbsapi` //rilac_bulk_sms
export const multi_role_service = `${DNS}/massapi` //multi_role_service
export const FILE_UPLOAD_BASE_URl = `${DNS}/fsapi` //file-system-service
// export const FILE_UPLOAD_BASE_URl = `http://filesystem:5001/rilacfsapi` //file-system-service
// export const FILE_UPLOAD_BASE_URl = `http://172.18.0.2:5001/fsapi` //file-system-service
export const group_management_base_url = `${DNS}/brgroup` //rilac group management
// export const group_management_base_url = `http://localhost:5001/brgroup` //rilac group management
export const almasjid_base_url = `${DNS}/eventmaster` //almasjid service

export const BRAC_GROUP_BASE_URL = group_management_base_url
export const DATAPACK_BASE_URL = `${DNS}/dpapi` /* datapack_service */
export const BMS_API_BASE_URL1 = `${DNS}/bms` //bms_agent_hierarchy/bms_service 2 kowshik vai
export const finify_subscription_manager = `${DNS}/finifysubscriptionmanager` //Subscription manager service
export const NJBC_base_url = `${DNS}/njbc` //nestjs_bms_crud
export const file_downloader_base_url = `${DNS}/rfdapi` //rilac group management
export const rasapi_base_url = `${DNS}/rasapi` //Rilac admin service
export const RCR_BASE_URL = `${DNS}/rcrapi` //file-system-service
export const merchantManagement_BASE_URL = `${DNS}/mtmgt/api` //finify merchant management service
export const download_csv_base_url = file_downloader_base_url //rilac group management

export const BMS_USER = `ratul`
export const BMS_PASS = `password1234`
export const BMS_USER1 = `redltd`
export const BMS_PASS1 = `UmVkSVRJbnRlcm5hdGlvbmFsQGJtc1Byb2plY3Q=`
// export const PHONE_PREFIX = `249`
export const PHONE_PREFIX = `44`
export const CURRENCY_SYMBOL = `£`
export const VERSION = `V-1.0`
export const TukitakiThemeColor = `#FC6A03`
export const REDIRECT_BASE_URL = `/`
 export const activityLimit = 900 //s
//export const activityLimit = 60000000 //s
//no need
//${DNS}/pmsnt
export const PMS_Notification_Template = `` //pms_notification_template //no need
//${DNS}/bms
export const Vendor_API_BASE_URL = `` //oms_vendor_service //no need
export const VideoUploadEndPoint = `` //oms_fileupload_brodcast //no need
export const PMSVietnam_API_BASE_URL = `` //no need
export const PMScore_API_BASE_URL = `` //no need
export const PMSVietnam2_API_BASE_URL = `` //no need
//${DNS}/pmssapi
export const PMS_service = `` //pms_service // No need